<template>
  <div class="row">
    <div class="col s12 l6">
      <div class="input-field">
        <textarea class="textarea-with-btn" :name="name" :id="name" v-model="getPromoWidget" readonly @focus="select"/>
        <button type='submit' class="btn-flat btn-copy" @click="copyPromoWidget()">
          <img src="../../assets/copy-icon.svg">
        </button>
      </div>
    </div>
    <div class="col s12 l6">
      <div class="widget-box" v-html="getPromoWidget"></div>
    </div>
  </div>
</template>

<script>
import Materialize from 'materialize-css'
import { mapGetters } from 'vuex'
import { copyToClipboard } from '@/services/helper'

export default {
  props: ['name'],
  beforeCreate () {
    if (typeof (window.mFindWidget) === 'undefined') {
      let scriptTag = document.createElement('script')
      scriptTag.src = process.env.AUTKA_WIDGET
      document.head.appendChild(scriptTag)
    }
  },
  created () {
    this.$store.dispatch('promoCode', 'get')
  },
  mounted () {
    this.asyncLoadAutkaWidget(() => {
      const widgetContainer = document.getElementsByClassName('mfind-widget')[0]

      if (typeof (widgetContainer) !== 'undefined') {
        window.mFindWidget.initialize(widgetContainer, {
          utmSource: widgetContainer.dataset.utmSource,
          utmMedium: widgetContainer.dataset.utmMedium,
          mpc: widgetContainer.dataset.mpc,
          brand: 'punkta'
        })
      }
    })
  },
  computed: {
    // mix the getters into the computed object
    ...mapGetters([
      'getPromoWidget'
    ])
  },
  methods: {
    select (e) {
      e.target.select()
    },
    copyPromoWidget () {
      const text = this.getPromoWidget
      if (text && copyToClipboard(text)) {
        Materialize.toast('Skopiowano kod widgetu', 2000)
      } else {
        Materialize.toast('Nie udało się skopiować widgetu', 1000)
      }
    },
    asyncLoadAutkaWidget (callback) {
      this.timeoutHolder = setTimeout(() => {
        clearTimeout(this.timeoutHolder)
        if (typeof window.mFindWidget !== 'undefined') {
          return callback()
        } else {
          this.asyncLoadAutkaWidget(callback)
        }
      }, 200) // 200ms
    }
  }
}
</script>

<style lang="scss">
@import './input.scss';

html #app .widget-box {
  margin-top: 1rem;

  select {
    display: inline;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// promoWidget.vue?599eecde